import { Link } from 'react-router-dom';

import logo from '../assets/logo.png';

import binance from '../assets/logo/Binance_Logo.svg.png';
import visa from '../assets/logo/Visa.png';
import mastercard from '../assets/logo/Mastercard.png';
import bancontact from '../assets/logo/Bancontact.png';


export default function Footer() {
    const currentYear = new Date().getFullYear();

    const links = {
        product: [
            { name: 'Inicio', href: '/' },
            { name: 'Precios', href: '/#pricing' },
            { name: 'Canales', href: '/#channels' },
            { name: 'Cómo funciona', href: '/#how' },
        ],
        support: [
            { name: 'FAQ', href: '/#faq' },
            { name: 'Guía de instalación', href: '#' },
            { name: 'Contacto', href: 'mailto:support@tvnimo.com' },
            { name: 'Prueba de velocidad', href: 'https://www.speedtest.net/' },
        ],
        legal: [
            { name: 'Condiciones de uso', href: '/terms' },
            { name: 'Política de privacidad', href: '/privacy' },
            { name: 'Política de reembolso', href: '/refund' },
        ]
    };

    return (
        <footer className="bg-black border-t border-white/10 pt-20 pb-10 relative overflow-hidden">
            {/* Background Glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-yellow-400/5 rounded-full blur-[100px]"></div>
                <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-[100px]"></div>
            </div>

            <div className="container mx-auto px-4 sm:px-6 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
                    {/* Brand Column */}
                    <div className="space-y-6">
                        {/* Logo */}
                        <Link to='/' className="flex items-center">
                            <img src={logo} alt="logo" className='w-[70px] h-auto rounded-[4px]' />
                        </Link>
                        <p className="text-gray-400 leading-relaxed">
                            La mejor experiencia IPTV en España. Más de 79,000 canales y VOD en calidad 4K/UHD. Estable, rápido y sin cortes.
                        </p>
                    </div>

                    {/* Links Columns */}
                    <div>
                        <h3 className="text-white font-bold text-lg mb-6">Enlaces rápidos</h3>
                        <ul className="space-y-4 mb-4">
                            {links.product.map((link) => (
                                <li key={link.name}>
                                    {link.href.startsWith('/') ? (
                                        <Link to={link.href} className="text-gray-400 hover:text-yellow-400 transition-colors duration-300">
                                            {link.name}
                                        </Link>
                                    ) : (
                                        <a href={link.href} className="text-gray-400 hover:text-yellow-400 transition-colors duration-300">
                                            {link.name}
                                        </a>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-white font-bold text-lg mb-6">Legal</h3>
                        <ul className="space-y-4">
                            {links.legal.map((link) => (
                                <li key={link.name}>
                                    <Link to={link.href} className="text-gray-400 hover:text-yellow-400 transition-colors duration-300">
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <div>
                            <h3 className="text-white font-bold text-lg mb-6">Contacto</h3>
                            <ul className='space-y-4'>
                                <li><a href="mailto:contact@tvsola.com" className='text-gray-400 hover:text-yellow-400 transition-colors duration-300'>contact@tvsola.com</a></li>
                                <li><a 
                                    href="https://wa.me/447478034690"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Contactar por WhatsApp"
                                    className='text-gray-400 hover:text-yellow-400 transition-colors duration-300'>+44 7478034690</a></li>
                            </ul>
                        </div>
                        <div className='mt-10'>
                            <h3 className="text-white font-bold text-lg mb-6">Pago</h3>
                            <ul className="flex space-x-4 space-y-4 items-center">
                                <li>
                                    <img src={binance} alt="" className='w-8 h-auto' />
                                </li>
                                <li>
                                    <img src={visa} alt="" className='w-12 h-auto' />
                                </li>
                                <li>
                                    <img src={mastercard} alt="" className='w-12 h-auto' />
                                </li>
                                <li>
                                    <img src={bancontact} alt="" className='w-12 h-auto' />
                                </li>
                            </ul>
                        </div>
                    </div>

                    
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-gray-500 text-sm">
                        © {currentYear} TVSOLA. Todos los derechos reservados.
                    </p>
                    <div className="flex items-center">
                        <div className="flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                            <span className="text-gray-400 text-sm">Sistema operativo</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
